import { useRef, type ReactNode } from 'react';
import { createApiClient } from '@/shared/api';
import { getToken } from '@/shared/auth';
import { readEnv } from '@/shared/config';
import {
  createPluginApi,
  PluginApiProvider,
  type PluginApiClient,
} from '@/entities/plugin';

const authProvider = { getToken };

export interface AppPluginApiProviderProps {
  children: ReactNode;
  /** Override the API client — intended for tests only. */
  client?: PluginApiClient;
}

export function AppPluginApiProvider({
  children,
  client,
}: AppPluginApiProviderProps) {
  const clientRef = useRef<PluginApiClient | null>(null);
  if (client === undefined && clientRef.current === null) {
    const baseUrl = readEnv('VITE_API_BASE_URL') ?? '';
    clientRef.current = createPluginApi(createApiClient({ baseUrl, auth: authProvider }));
  }

  const resolvedClient = client ?? clientRef.current;
  if (resolvedClient === null) {
    throw new Error('AppPluginApiProvider could not initialize a plugin API client');
  }

  return (
    <PluginApiProvider client={resolvedClient}>
      {children}
    </PluginApiProvider>
  );
}
